import { render, staticRenderFns } from "./CategoriesForm.vue?vue&type=template&id=fbc5d6be&scoped=true&"
import script from "./CategoriesForm.vue?vue&type=script&lang=js&"
export * from "./CategoriesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc5d6be",
  null
  
)

export default component.exports